import $ from 'jquery';
import ACTION from '../action_constant';
import {ajaxPost, ajaxGetWithToken, ajaxGet, ajaxPostWithToken} from '../util/ajax';
import API from '../api_config';
import ls from '../util/localstorage';
import cookie from '../util/cookie';
import CONSTANTS from '../common_constants';

function storeSessionOnCookie(data){
  const cookieData = {
  userId : data.userId,
  token : data.token,
  name : data.name,
  email : data.email,
  profileImageUrl : data.profileImageUrl,
  isVerified : data.isVerified,
  phoneNumber : data.phoneNumber,
  countryCode : data.countryCode,
  phoneNumberWithoutCountryCode : data.phoneNumberWithoutCountryCode,
  isFacebookLogin : data.isFacebookLogin,
  sessionValid : data.sessionValid,
  userVerificationDocumentImageUrl : data.userVerificationDocumentImageUrl
  }
  cookie.set('_sd',JSON.stringify(cookieData),60*24*60*60); // store token for 60 days
}

const authActions = {
  /**
  * method to store session data in cookie and state tree
  * @param  {[type]} data [description]
  * @return {[type]}      [description]
  */
  storeSessionData: function(data){
    storeSessionOnCookie(data);
    return {
      type : ACTION.STORESESSIONDATA,
      data : data
    }
  },
  setSessionData: function(sessionData){
    return {
      type : ACTION.STORESESSIONDATA,
      data : sessionData
    };
  },
  clearData: function(){
    return {
      type : ACTION.CLEAR_AUTH_DATA
    }
  },
  signupWithEmail: function(paramObj){
    return function(dispatch){
      const promise =  ajaxPost({
        url : API.signUpWithEmail,
        data : paramObj,
        success : (data)=>{
          storeSessionOnCookie(data);
        },
        error: (err) => {
        },
        action : ACTION.SIGNUP.EMAIL,
        dispatch : dispatch
      })
      return promise;
    }
  },
  registerPhoneNumber: function(paramObj, interimSessionToken){
    return function(dispatch){
      const promise = $.ajax({
          url : API.registerPhoneNumber,
          type : 'POST',
          contentType: 'application/json',
          data : JSON.stringify(paramObj),
          headers: {'interimSessionToken': interimSessionToken},
          crossDomain : true,
          dataType: 'json',
          success : (data) => {
            storeSessionOnCookie(data);
            dispatch({
              type : ACTION.SIGNUP.EMAIL,
              data : data,
              status : "success"
            })
          },
          error : (error) => {
          },
        });
        return promise;
    }
  },
  signupWithFacebook : function(){
    return function(dispatch){
      const deferred = $.Deferred();
      //login with fb
      FB.login((response) => {
        if (response.authResponse) {
          const fbData = response.authResponse;

          //load facebook profile data
          FB.api('/me/', {fields: ['email', 'first_name','last_name','picture']}, (profileData) => {

            const userName = profileData.first_name +' '+ profileData.last_name;
            const userImageUrl = profileData.picture ? profileData.picture.data.url : '';

            deferred.resolve({
              userName : userName,
              firstName : profileData.first_name,
              lastName : profileData.last_name,
              facebookId : fbData.userID,
              email: profileData.email,
              fbToken : fbData.accessToken,
              profileImageUrl:userImageUrl
            })
          });

        } else {
          deferred.reject();
        }
      },{scope:'public_profile, email'});

      return deferred.promise();
    }
  },
  completeSignupWithFacebook(dataObj) {
    return function(dispatch) {
      const deferred = $.Deferred();

      //signup with facebook
      ajaxPost({
        url : API.signUpWithFacebook,
        data : {
          facebookId : dataObj.facebookId,
          accessToken : dataObj.fbToken,
          name : dataObj.userName,
          email: dataObj.email,
          profileImageUrl: dataObj.profileImageUrl,
          deviceId: "12345",
          deviceTypeId : 3
        },
        success : (data)=>{
          storeSessionOnCookie(data);
        },
        error: (err) => {
          deferred.reject(err);
        },
        action : ACTION.SIGNUP.FACEBOOK,
        dispatch : dispatch
      }).then((data) => {
         deferred.resolve(data);
      }, deferred.reject);
      return deferred.promise();
    }
  },
  signinWithEmail : function(email, password){
    return (dispatch)=>{
      const promise = ajaxPost({
        url : API.signinWithEmail,
        data : {
          email,
          password,
          deviceTypeId : 3,
          deviceId: "123454321"
        },
        success : (data) =>{
          data.isFacebookLogin = false;
          data.sessionValid = true;
          storeSessionOnCookie(data);
          amplitude.getInstance().setUserId(email);
          amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.EMAIL_SIGN_SUCCESS);
        },
        error: (err) => {
        },
        action : ACTION.SIGNIN.EMAIL,
        dispatch : dispatch
      });
      return promise;
    }
  },
  signinWithFacebook : function(){
    return function(dispatch){
      const deferred = $.Deferred();
      FB.login((response) => {

        if (response.authResponse) {
          const fbData = response.authResponse

          ajaxPost({
            url : API.signinWithFacebook,
            data : {
              facebookId : fbData.userID,
              accessToken : fbData.accessToken,
              deviceTypeId : 3,
              deviceId: "12124"
            },
            success : (data)=>{
              data.isFacebookLogin = true;
              data.sessionValid = true;
              storeSessionOnCookie(data);
              if(data.email) amplitude.getInstance().setUserId(data.email);
              amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.FB_SIGN_SUCCESS);
            },
            action : ACTION.SIGNIN.FACEBOOK,
            dispatch : dispatch
          }).then((data) => {
            deferred.resolve(data);
          }, (error) => {
            return deferred.reject(error);
          });
        } else {
          deferred.reject();
        }
      },{scope:'public_profile, email'});

      return deferred.promise();
    }
  },
  forgotPassword : function(email){
    return function(dispatch){
      const promise =  ajaxPost({
        url : API.forgotPassword,
        data : {
          email
        },
        success: function(data) {
        },
        error: function(err) {
        }
      })
      return promise;
    }
  },
  logout: function(){
    return (dispatch) => {
      const promise = ajaxGetWithToken({
        url: API.signout,
        success: function(data){
          // console.log(data);
        },
        error: function(data){
          // console.log(data);
        }
      });
      return promise;
    }
  },
  resetPassword: function(email){
    return function(dispatch){
      const promise = ajaxPost({
        url: API.forgotPassword,
        data: {
          email
        },
        success: function(data){

        },
        error: function(err){

        }
      });
      return promise;
    }

  },
  sessionValid:function(data){
    return (dispatch) =>{
      dispatch({
        type : ACTION.SESSION_VALID,
        data : {sessionValid: data}
      })
    }
  },
  idVerification : function(paramObj){
    return (dispatch) => {
      return ajaxPostWithToken({
          url : API.verifyUser,
          data: paramObj,
          success: (data) => {
            dispatch({
              type : ACTION.VERIFICATION,
              data : paramObj
            })
          },
          error: (error) => {
          }
      });
    }
  },
  editProfileImage : function(paramObj){
    return (dispatch) => {
      return ajaxPostWithToken({
          url : API.editProfileImage,
          data: paramObj,
          success: (data) => {
            dispatch({
              type : ACTION.EDIT_PROFILE_IMAGE,
              data : paramObj
            })
          },
          error: (error) => {
          }
      });
    }
  }
}
module.exports = authActions;



// WEBPACK FOOTER //
// app/auth/auth_actions.jsx